import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Grid, Typography, Typography2 } from '@coursera/cds-core';

import Carousel from 'bundles/design-system/components/Carousel';
import type { Maybe } from 'bundles/xddp/__generated__/baseContentfulTypes';
import type { MarketingContentFieldsFragment } from 'bundles/xddp/__generated__/contentfulTypes';
import Container from 'bundles/xddp/components/shared/Container';
import type { RelatedNewsProp } from 'bundles/xddp/types';

import _t from 'i18n!nls/xddp';

import 'css!bundles/xddp/components/__styles__/homepage/RelatedNews';

const NewsArticle = (newsArticle: Maybe<MarketingContentFieldsFragment>) => {
  if (!newsArticle) {
    return null;
  }

  return (
    <Grid item lg={12} md={12} sm={12} key={newsArticle.title} css={{ padding: '0 var(--cds-spacing-150)' }}>
      <div className="news-article">
        <div className="article-info">
          {newsArticle.visual && (
            <a
              className="noDecoration"
              href={newsArticle.callToActionLink ?? ''}
              target={newsArticle.openLinkInNewTab ? '_target' : '_self'}
            >
              <Imgix className="article-banner" src={newsArticle.visual.url ?? ''} alt={newsArticle.title ?? ''} />

              <Typography2 component="h3" className="article-title" variant="subtitleMedium">
                {newsArticle.title}
              </Typography2>
            </a>
          )}

          <Typography2 component="p" className="article-description" variant="bodyPrimary">
            {newsArticle.description}
          </Typography2>
        </div>
      </div>
    </Grid>
  );
};

const RelatedNews = ({ relatedNews }: RelatedNewsProp) => {
  if (!relatedNews || !relatedNews.length) {
    return null;
  }

  return (
    <div className="rc-RelatedNews rc-CenteredHeaderSection styled">
      <Container>
        <Typography className="section-header-center" variant="h2">
          {_t('News')}
        </Typography>
        <Grid container className="carousel-row" justifyContent="center">
          <div className="carousel-container">
            <Carousel enableVisibilityTracking={false}>{relatedNews.map(NewsArticle)}</Carousel>
          </div>
        </Grid>
      </Container>
    </div>
  );
};

export default RelatedNews;
